import React from 'react';

export default {

    Ring() {
        return (
            <svg className="icon" viewBox="0 0 16 16">
                <circle r="6.5" cx="8" cy="8" stroke="currentColor" strokeWidth="3" fillOpacity="0"/>
            </svg>
        )
    },

    CaretDown() {
        return (
            <svg className="icon" viewBox="0 0 10 5">
                <polygon points="10 0 5 5 0 0" fill="currentColor"/>
            </svg>
        )
    },

    CaretRight() {
        return (
            <svg className="icon" viewBox="0 0 5 10">
                <polygon points="0 0 5 5 0 10" fill="currentColor"/>
            </svg>
        )
    },

    ChevronRight() {
        return (
            <svg className="icon" viewBox="0 0 16 13">
                <g stroke="currentColor" strokeWidth="2" fill="none" fillRule="evenodd" strokeLinecap="round"
                   strokeLinejoin="round">
                    <path d="M15 6.5H15M10 1.5l5 5-5 5"/>
                </g>
            </svg>
        )
    },

    ArrowLeft() {
        return (
            <svg className="icon" viewBox="0 0 16 13">
                <g stroke="currentColor" strokeWidth="1.5" fill="none" fillRule="evenodd" strokeLinecap="round"
                   strokeLinejoin="round">
                    <path d="M14.547 6.5H1M6 11.5l-5-5 5-5"/>
                </g>
            </svg>
        )
    },

    ArrowRight() {
        return (
            <svg className="icon" viewBox="0 0 16 13">
                <g stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd"
                   stroke-linecap="round" stroke-linejoin="round">
                    <path d="M1.453 6.5H15M10 1.5l5 5-5 5"/>
                </g>
            </svg>
        )
    }

};
